// extracted by mini-css-extract-plugin
export default {"loader-container":"LoadingSpinner_loader-container__5Y6dH","spinner":"LoadingSpinner_spinner__hRYy1","spin":"LoadingSpinner_spin__cQm7Q"};